import { Component, Inject, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { NgxDropzoneChangeEvent } from "ngx-dropzone";
import { HttpClient } from "@angular/common/http";
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertService } from "../../../../../libs/services/src/lib/alert.service";
import { NgxDropzoneModule } from "ngx-dropzone";
import { CommonModule } from "@angular/common";
import { MatLabel } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { PageContentWrapperComponent } from "../../features/page-content-wrapper/page-content-wrapper.component";
import { ENVIRONMENT } from "../../../../../libs/models/src/lib/injection.tokens";
@Component({
  selector: "app-design-services",
  standalone: true,
  templateUrl: "./design-services.component.html",
  styleUrls: ["./design-services.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDropzoneModule,
    MatLabel,
    MatOptionModule,
    MatSelectModule,
    PageContentWrapperComponent
  ],
})
export class DesignServicesComponent implements OnInit {
  emailSent = false;
  firstName = "";
  lastName = "";
  email = "";
  phone = "";
  type = "";
  message = "";
  files: any[] = [];

  firstNameControl = new FormControl(this.firstName, [Validators.required]);
  lastNameControl = new FormControl(this.lastName, [Validators.required]);
  emailControl = new FormControl(this.email, [Validators.required, Validators.email]);
  phoneControl = new FormControl(this.phone, [
    Validators.required,
    Validators.pattern("^(\\+\\d{1,2}\\s?)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$"),
  ]);
  typeControl = new FormControl(this.type, [Validators.required]);
  messageControl = new FormControl(this.message, [Validators.required]);

  config: any;
  imagesReady = true;
  wasValidated: boolean = false;

  supportPhone: string = this.env.config.supportPhone;
  supportEmail: string = "mailto:" + this.env.config.supportEmail;

  constructor(private httpClient: HttpClient, private alertSvc: AlertService, @Inject(ENVIRONMENT) private env: any) {}

  ngOnInit() {
    this.config = environment.config;
    window.scroll(0, 0);
  }

  goBack() {
    window.history.back();
  }

  public scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  public processImage($event: NgxDropzoneChangeEvent) {
    this.imagesReady = false;
    $event.addedFiles.forEach((value) => {
      console.log("reading file", value);
      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = () => {
        this.files.push({
          filename: value.name,
          type: value.type,
          content: reader.result,
        });
        this.imagesReady = $event.addedFiles.length === this.files.length;
      };
    });
  }

  removeImage(file: any) {
    console.log("removing file", file);
    const files: any[] = [];
    this.files.forEach((value) => {
      if (value.filename !== file.filename) {
        files.push(value);
      }
    });
    this.files = files;
  }

  get isValid() {
    return (
      this.firstNameControl.valid &&
      this.lastNameControl.valid &&
      this.emailControl.valid &&
      this.typeControl.valid &&
      this.messageControl.valid &&
      this.phoneControl.valid &&
      this.imagesReady
    );
  }

  get body() {
    return {
      firstName: this.firstNameControl.value,
      lastName: this.lastNameControl.value,
      email: this.emailControl.value,
      phone: this.phoneControl.value,
      type: this.typeControl.value,
      message: this.messageControl.value,
      images: this.files,
    };
  }

  send() {
    this.wasValidated = true;
    if (this.isValid) {
      const url = `${environment.apiHost}/ecom/services/email`;
      return new Promise<any>((resolve, reject) => {
        this.httpClient.post(url, this.body).subscribe(
          (res) => {
            this.emailSent = true;
            resolve(res);
          },
          (error) => {
            this.emailSent = false;
            this.alertSvc.showError({ msg: "Email Not Sent - Failed to send the email, please try again later." });
            reject(error.message || error);
          }
        );
      });
    } else {
      this.alertSvc.showError({ msg: "Email Not Sent - Please fill out all required fields." });
      return Promise.reject("Form is not valid");
    }
  }
}
